module.exports = __webpack_public_path__ + "img/shangye_xinhua_suoluetu.dd764aa8.png";